var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.75 7H4.75C4.15326 7 3.58097 7.23705 3.15901 7.65901C2.73705 8.08097 2.5 8.65326 2.5 9.25V27.25C2.5 27.8467 2.73705 28.419 3.15901 28.841C3.58097 29.2629 4.15326 29.5 4.75 29.5H31.75C32.3467 29.5 32.919 29.2629 33.341 28.841C33.7629 28.419 34 27.8467 34 27.25V9.25C34 8.65326 33.7629 8.08097 33.341 7.65901C32.919 7.23705 32.3467 7 31.75 7ZM31.75 9.25V12.625H4.75V9.25H31.75ZM31.75 27.25H4.75V14.875H31.75V27.25ZM29.5 23.875C29.5 24.1734 29.3815 24.4595 29.1705 24.6705C28.9595 24.8815 28.6734 25 28.375 25H23.875C23.5766 25 23.2905 24.8815 23.0795 24.6705C22.8685 24.4595 22.75 24.1734 22.75 23.875C22.75 23.5766 22.8685 23.2905 23.0795 23.0795C23.2905 22.8685 23.5766 22.75 23.875 22.75H28.375C28.6734 22.75 28.9595 22.8685 29.1705 23.0795C29.3815 23.2905 29.5 23.5766 29.5 23.875ZM20.5 23.875C20.5 24.1734 20.3815 24.4595 20.1705 24.6705C19.9595 24.8815 19.6734 25 19.375 25H17.125C16.8266 25 16.5405 24.8815 16.3295 24.6705C16.1185 24.4595 16 24.1734 16 23.875C16 23.5766 16.1185 23.2905 16.3295 23.0795C16.5405 22.8685 16.8266 22.75 17.125 22.75H19.375C19.6734 22.75 19.9595 22.8685 20.1705 23.0795C20.3815 23.2905 20.5 23.5766 20.5 23.875Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.4efb0711d4f8f34592a8e984addd20f0.svg";
export { ForwardRef as ReactComponent };